// Recognise only the API's fixed safety messages; never display arbitrary details.
export function isTestRecipientRejection(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const problem = error as { status?: unknown; detail?: unknown };
  return (
    problem.status === 403 &&
    (problem.detail ===
      "Local live delivery contains a recipient outside the approved address list." ||
      problem.detail ===
        "Staging delivery contains a recipient outside the approved test list." ||
      problem.detail === "Local live delivery requires an approved recipient.")
  );
}
